/** favicar.ru and its staging favicar.devru are the RU contour: its own API, country and links. */
export const isRuDomain = (hostname: string = window.location.hostname): boolean => /\.(dev)?ru$/.test(hostname)

/** Support address of the portal instance: Favicar has its own per domain (favicar.ru → support@favicar.ru). */
export const getSupportEmail = (isFavicar: boolean, hostname: string = window.location.hostname): string =>
    isFavicar ? `support@favicar.${isRuDomain(hostname) ? 'ru' : 'com'}` : 'support@cardone.by'
